/**
 *   Created by ATopcu in 2019
 */

import { fetchFactorTypes, fetchFactorPeriods } from "@ls/grouping-service";
import { selectBaseGroupingParams } from "state/selections/selector";
import SummaryType from "state/selections/Constants/SummaryType";
import { exchange } from "@ls/js-fetch";
import { selectDefinitions } from "state/factrib/selectors";
import SelectionState from "state/selections/SelectionState";
import { throwError } from "@ls/error-module";
import scope from "./scope";

export const SET_DEFINITION = `${scope}/SET_DEFINITION`;
export const setDefinition = (idx, definition) => ({
  type: SET_DEFINITION,
  idx,
  definition,
});

export const SET_DEFINITIONS = `${scope}/SET_DEFINITIONS`;
export const setDefinitions = (definitions) => ({
  type: SET_DEFINITIONS,
  definitions,
});

export const REQUEST_DATA = `${scope}/REQUEST_ABS_DATA`;
export const RECEIVE_DATA = `${scope}/RECEIVE_ABS_DATA`;
const url = process.env.REACT_APP_BASE_URL_GROUPING_SERVICE;

export const requestNormalFactorAttributionData = (definitions) => {
  return async (dispatch, getState) => {
    const state = getState();
    const {
      absFactribPeriods,
      absFactribFactors,
      relFactribPeriods,
      relFactribFactors,
    } = separateDefinitions(definitions);

    const [baseParams] = selectBaseGroupingParams(state);

    if (absFactribFactors.length) {
      dispatch({
        type: REQUEST_DATA,
        payload: { summary: SummaryType.ABSOLUTE },
      });
      exchange({
        baseURL: url,
        cancelId: "factor_attrib_abs",
        params: {
          ...baseParams,
          results: baseParams.results + ",SECURITY_LEVEL_ATTRIBUTES_GLOBAL",
          summary: SummaryType.ABSOLUTE,
          factrib_factors: absFactribFactors.join(","),
          factrib_periods: absFactribPeriods.join(","),
        },
      }).then(({ data }) =>
        dispatch({
          type: RECEIVE_DATA,
          payload: { summary: SummaryType.ABSOLUTE, data },
        })
      );
    }

    if (relFactribFactors.length) {
      dispatch({
        type: REQUEST_DATA,
        payload: { summary: SummaryType.RELATIVE },
      });
      exchange({
        baseURL: url,
        cancelId: "factor_attrib_rel",
        params: {
          ...baseParams,
          results: baseParams.results + ",SECURITY_LEVEL_ATTRIBUTES_GLOBAL",
          summary: SummaryType.RELATIVE,
          factrib_factors: relFactribFactors.join(","),
          factrib_periods: relFactribPeriods.join(","),
        },
      }).then(({ data }) =>
        dispatch({
          type: RECEIVE_DATA,
          payload: { summary: SummaryType.RELATIVE, data },
        })
      );
    }
  };
};

export const REQUEST_ALT_DATE_DATA = `${scope}/REQUEST_ABS_ALT_DATE_DATA`;
export const RECEIVE_ALT_DATE_DATA = `${scope}/RECEIVE_ABS_ALT_DATE_DATA`;
export const requestAltDateFactorAttributionData = (definitions) => {
  return async (dispatch, getState) => {
    const state = getState();

    const definitionsByAsOfDate = {};
    definitions.forEach((definition) => {
      const { factribAsOfDate } = definition;
      if (!definitionsByAsOfDate[factribAsOfDate]) {
        definitionsByAsOfDate[factribAsOfDate] = [];
      }
      definitionsByAsOfDate[factribAsOfDate].push(definition);
    });

    const [baseParams] = selectBaseGroupingParams(state);

    Object.keys(definitionsByAsOfDate).forEach((asOfDate) => {
      const {
        absFactribPeriods,
        absFactribFactors,
        relFactribPeriods,
        relFactribFactors,
      } = separateDefinitions(definitionsByAsOfDate[asOfDate]);
      if (absFactribFactors.length) {
        dispatch({
          type: REQUEST_ALT_DATE_DATA,
          payload: { asOfDate, summary: SummaryType.ABSOLUTE },
        });
        exchange({
          baseURL: url,
          cancelId: `alt-date-factor_attrib_abs_${asOfDate}`,
          params: {
            ...baseParams,
            results: baseParams.results + ",SECURITY_LEVEL_ATTRIBUTES_GLOBAL",
            dates: asOfDate,
            summary: SummaryType.ABSOLUTE,
            factrib_factors: absFactribFactors.join(","),
            factrib_periods: absFactribPeriods.join(","),
          },
        }).then(({ data }) =>
          dispatch({
            type: RECEIVE_ALT_DATE_DATA,
            payload: { asOfDate, summary: SummaryType.ABSOLUTE, data },
          })
        );
      }
      if (relFactribFactors.length) {
        dispatch({
          type: REQUEST_ALT_DATE_DATA,
          payload: { asOfDate, summary: SummaryType.RELATIVE },
        });
        exchange({
          baseURL: url,
          cancelId: `alt-date-factor_attrib_rel_${asOfDate}`,
          params: {
            ...baseParams,
            results: baseParams.results + ",SECURITY_LEVEL_ATTRIBUTES_GLOBAL",
            dates: asOfDate,
            summary: SummaryType.RELATIVE,
            factrib_factors: relFactribFactors.join(","),
            factrib_periods: relFactribPeriods.join(","),
          },
        }).then(({ data }) =>
          dispatch({
            type: RECEIVE_ALT_DATE_DATA,
            payload: { asOfDate, summary: SummaryType.RELATIVE, data },
          })
        );
      }
    });
  };
};

const separateDefinitions = (definitions) => {
  const absFactribPeriods = new Set(),
    absFactribFactors = new Set(),
    relFactribPeriods = new Set(),
    relFactribFactors = new Set();

  definitions.forEach((definition) => {
    const { factribPeriod, factribFactor, summary } = definition;
    switch (summary) {
      case SummaryType.ABSOLUTE:
        absFactribPeriods.add(factribPeriod);
        absFactribFactors.add(factribFactor);
        break;
      case SummaryType.RELATIVE:
        relFactribPeriods.add(factribPeriod);
        relFactribFactors.add(factribFactor);
        break;
      default:
        throw new Error(`Unknown summary ${summary}`);
    }
  });

  return {
    absFactribPeriods: [...absFactribPeriods],
    absFactribFactors: [...absFactribFactors],
    relFactribPeriods: [...relFactribPeriods],
    relFactribFactors: [...relFactribFactors],
  };
};
export const requestFactorAttributionData = () => {
  return async (dispatch, getState) => {
    const state = getState();
    const factribDefinitions = selectDefinitions(SelectionState.COMMITTED)(
      state
    );

    const normalDefinitions = [];
    const altDateDefinitions = [];

    factribDefinitions.forEach((definition) => {
      if (definition.factribAsOfDate) {
        altDateDefinitions.push(definition);
      } else {
        normalDefinitions.push(definition);
      }
    });

    if (normalDefinitions.length) {
      dispatch(requestNormalFactorAttributionData(normalDefinitions));
    }
    if (altDateDefinitions.length) {
      dispatch(requestAltDateFactorAttributionData(altDateDefinitions));
    }
  };
};

export const REQUEST_FACTRIB_TYPES = `${scope}/REQUEST_FACTRIB_TYPES`;
export const RECEIVE_FACTRIB_TYPES = `${scope}/RECEIVE_FACTRIB_TYPES`;
export const requestFactribTypes = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_FACTRIB_TYPES });
    try {
      dispatch({
        type: RECEIVE_FACTRIB_TYPES,
        payload: {
          data: await fetchFactorTypes(),
        },
      });
    } catch (e) {
      dispatch({ type: RECEIVE_FACTRIB_TYPES, data: [] });
      throwError(e);
    }
  };
};

export const REQUEST_FACTRIB_PERIODS = `${scope}/REQUEST_FACTRIB_PERIODS`;
export const RECEIVE_FACTRIB_PERIODS = `${scope}/RECEIVE_FACTRIB_PERIODS`;
export const requestFactribPeriods = () => {
  return async (dispatch) => {
    dispatch({ type: REQUEST_FACTRIB_PERIODS });
    try {
      dispatch({
        type: RECEIVE_FACTRIB_PERIODS,
        payload: {
          data: await fetchFactorPeriods(),
        },
      });
    } catch (e) {
      dispatch({ type: RECEIVE_FACTRIB_PERIODS, data: [] });
      throwError(e);
    }
  };
};
